import { Injectable, inject } from '@angular/core';
import { NivelAcesso } from '../models/nivel-acesso.model';
import { SessaoStore } from '../store/sessao.store';

@Injectable({ providedIn: 'root' })
export class PermissaoNivelService {
  private readonly sessao = inject(SessaoStore);

  podeAdministrar(): boolean { return this.sessao.nivel() === NivelAcesso.Administrador; }
  podeCadastrarRc(): boolean { return this.excetoNivel4(); }
  podeCadastrarSac(): boolean { return this.excetoNivel4(); }
  podeCadastrarOis(): boolean { return this.podeAdministrar(); }
  podeGerenciarGerentes(): boolean { return this.podeAdministrar(); }
  podeEditarValorAcumuladoRc(): boolean { return this.podeAdministrar(); }
  podeAlterarValorRc(): boolean { return this.podeAdministrar(); }
  podeExcluirRc(): boolean { return this.podeAdministrar(); }
  podeAtualizarDadosOis(): boolean { return this.podeAdministrar(); }
  podeAtualizarPrevisaoMensalOis(): boolean {
    return this.podeAdministrar() || this.sessao.nivel() === NivelAcesso.Nivel2;
  }

  permiteNiveis(niveis?: readonly number[]): boolean {
    if (!niveis) return true;
    // [1,2,3] declara a regra ≠4 da matriz, não uma lista fechada para níveis desconhecidos.
    if (niveis.length === 3 && [1, 2, 3].every(n => niveis.includes(n))) return this.excetoNivel4();
    const nivel = this.sessao.nivel();
    return nivel !== null && niveis.includes(nivel);
  }

  private excetoNivel4(): boolean { return this.sessao.nivel() !== NivelAcesso.Nivel4; }
}
